/**
 * Shared stage-colour map for Engage (Hospital CRM) enquiry statuses.
 * Mirrors TrustEdge's leadStageBadge but scoped to hospital-specific stages.
 */
export const ENGAGE_STATUS_BADGE = {
    'new':                  'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
    'contacted':            'bg-cyan-100 text-cyan-700 dark:bg-cyan-900/30 dark:text-cyan-300',
    'interested':           'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300',
    'appointment_booked':   'bg-teal-100 text-teal-700 dark:bg-teal-900/30 dark:text-teal-300',
    'consulted':            'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
    'under_treatment':      'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-300',
    'follow_up_required':   'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300',
    'converted':            'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300',
    'dropped':              'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300',
    'lost':                 'bg-red-50 text-red-500 dark:bg-red-900/20 dark:text-red-400',
};

export const ENGAGE_STATUS_DEFAULT = 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-400';

export const getEngageStatusBadge = (status) =>
    ENGAGE_STATUS_BADGE[status] || ENGAGE_STATUS_DEFAULT;

/** Human label for an Engage status code. */
export const ENGAGE_STATUS_LABEL = {
    'new':                  'New',
    'contacted':            'Contacted',
    'interested':           'Interested',
    'appointment_booked':   'Appointment Booked',
    'consulted':            'Consulted',
    'under_treatment':      'Under Treatment',
    'follow_up_required':   'Follow-up Required',
    'converted':            'Converted',
    'dropped':              'Dropped',
    'lost':                 'Lost',
};

export const ENGAGE_STATUS_ORDER = [
    'new', 'contacted', 'interested', 'appointment_booked',
    'consulted', 'under_treatment', 'follow_up_required',
    'converted', 'dropped', 'lost',
];

/** ── Sources (channel) ──────────────────────────────────────────────────── */

export const ENGAGE_SOURCE_LABEL = {
    'phone':               'Phone',
    'whatsapp':            'WhatsApp',
    'website':             'Website',
    'walk_in':             'Walk-in',
    'staff_referral':      'Staff Referral',
    'doctor_referral':     'Doctor Referral',
    'ambulance_referral':  'Ambulance',
    'health_camp':         'Health Camp',
    'corporate_account':   'Corporate',
    'insurance':           'Insurance / TPA',
    'digital_marketing':   'Digital Marketing',
    'word_of_mouth':       'Word of Mouth',
    'emergency_108':       '108 Emergency',
    'social_media':        'Social Media',
    'corporate':           'Corporate',
    'other':               'Other',
};

export const ENGAGE_SOURCE_BADGE = {
    'phone':               'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
    'whatsapp':            'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300',
    'website':             'bg-indigo-100 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-300',
    'walk_in':             'bg-slate-100 text-slate-700 dark:bg-slate-900/30 dark:text-slate-300',
    'staff_referral':      'bg-fuchsia-100 text-fuchsia-700 dark:bg-fuchsia-900/30 dark:text-fuchsia-300',
    'doctor_referral':     'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300',
    'ambulance_referral':  'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-300',
    'health_camp':         'bg-pink-100 text-pink-700 dark:bg-pink-900/30 dark:text-pink-300',
    'corporate_account':   'bg-teal-100 text-teal-700 dark:bg-teal-900/30 dark:text-teal-300',
    'insurance':           'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300',
    'digital_marketing':   'bg-cyan-100 text-cyan-700 dark:bg-cyan-900/30 dark:text-cyan-300',
    'word_of_mouth':       'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
    'emergency_108':       'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300',
    'social_media':        'bg-sky-100 text-sky-700 dark:bg-sky-900/30 dark:text-sky-300',
    'corporate':           'bg-teal-100 text-teal-700 dark:bg-teal-900/30 dark:text-teal-300',
    'other':               'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300',
};

export const getEngageSourceBadge = (source) =>
    ENGAGE_SOURCE_BADGE[source] || ENGAGE_SOURCE_BADGE['other'];

export const getEngageSourceLabel = (source) =>
    ENGAGE_SOURCE_LABEL[source] || (source || 'unknown').replace(/_/g, ' ');
